module.exports = __webpack_public_path__ + "images/applex2.png";